/**
 * Terms — 이용약관 페이지 (/terms)
 *
 * 브랜드: 인증이지 (CERT EASY)
 * 법적 서비스 공급자: 주식회사 메이커머스
 *
 * 구조 (전자상거래법 + 약관규제법 기준):
 *   제1조 목적 / 제2조 정의 / 제3조 약관의 효력 및 변경
 *   제4조 서비스의 제공 및 변경 / 제5조 서비스 이용신청 및 성립
 *   제6조 이용자의 의무 / 제7조 회사의 의무 / 제8조 개인정보 보호
 *   제9조 서비스 이용제한 / 제10조 계약해지 / 제11조 면책조항
 *   제12조 분쟁해결 / 부칙
 *
 * 회사 정보는 COMPANY 상수에서 import
 * 공식 문의 이메일은 메이커머스 컨펌안에 따라 privacy@taxcube.kr 로 통일
 */
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { COMPANY } from '@/config/constants';
import { Header } from '@/components/common/Header';
import { Footer } from '@/components/common/Footer';

/** 본 페이지 한정 — 공식 문의 이메일 (Privacy와 동일하게 통일) */
const CONTACT_EMAIL = 'privacy@taxcube.kr';

export function Terms() {
  // 페이지 진입 시 상단 스크롤
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-root">
      <Header onOpenB2B={() => { window.location.href = '/'; }} />
      <main
        style={{
          background: '#fff',
          color: '#222',
          minHeight: '60vh',
        }}
      >
      <div
      className="terms-page"
      style={{
        maxWidth: 880,
        margin: '0 auto',
        padding: '60px 24px',
        lineHeight: 1.8,
        fontSize: 15,
        color: '#222',
      }}
    >
      <header style={{ marginBottom: 40, paddingBottom: 24, borderBottom: '2px solid #0B1829' }}>
        <h1 style={{ fontSize: 32, fontWeight: 700, marginBottom: 8 }}>이용약관</h1>
        <p style={{ color: '#666', fontSize: 14 }}>
          {COMPANY.brandKo} ({COMPANY.brandEn}) · 서비스 공급자: {COMPANY.legalNameKo}
        </p>
      </header>

      <p>
        본 약관은 {COMPANY.legalNameKo}(이하 "회사", 사업자등록번호: {COMPANY.businessNumber})가
        "{COMPANY.brandKo}" 브랜드로 제공하는 경영컨설팅, 벤처인증, 기업부설연구소, ISO인증,
        경리 운영 지원 관련 상담 및 컨설팅 서비스(이하 "서비스")의 이용에 관한 조건과 절차, 회사와
        이용자의 권리·의무·책임사항 및 기타 필요한 사항을 규정함을 목적으로 합니다.
      </p>

      <h2 style={h2Style}>제1조 (목적)</h2>
      <p>
        이 약관은 회사가 제공하는 서비스의 이용과 관련하여 회사와 이용자의 권리·의무 및 책임사항,
        기타 필요한 사항을 규정함을 목적으로 합니다.
      </p>

      <h2 style={h2Style}>제2조 (정의)</h2>
      <p>이 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
      <p>
        1. "서비스"란 회사가 "{COMPANY.brandKo}" 브랜드로 제공하는 경영컨설팅, 벤처인증,
        기업부설연구소 운영, ISO인증, 경리 운영 지원 관련 상담 및 컨설팅 서비스 일체를 말합니다.
        <br />
        2. "이용자"란 본 사이트에 접속하여 이 약관에 따라 회사가 제공하는 서비스를 이용하는 법인 및
        개인사업자를 말합니다.
        <br />
        3. "상담신청"이란 이용자가 본 사이트의 신청 양식을 통해 회사에 컨설팅 상담을 요청하는
        행위를 말합니다.
        <br />
        4. "컨설팅 계약"이란 상담 후 이용자와 회사 간에 별도로 체결하는 정식 용역 계약을 말합니다.
      </p>

      <h2 style={h2Style}>제3조 (약관의 효력 및 변경)</h2>
      <p>
        ① 이 약관은 본 사이트에 게시함으로써 효력이 발생합니다.
        <br />
        ② 회사는 필요한 경우 관계법령을 위반하지 않는 범위 내에서 이 약관을 변경할 수 있으며,
        약관을 변경할 경우 적용일자 및 변경사유를 명시하여 적용일자 7일 전부터 본 사이트에
        공지합니다.
        <br />
        ③ 이용자가 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 이용계약을 해지할 수
        있습니다. 변경된 약관의 효력 발생일 이후에도 서비스를 계속 이용할 경우 약관의 변경사항에
        동의한 것으로 간주됩니다.
      </p>

      <h2 style={h2Style}>제4조 (서비스의 제공 및 변경)</h2>
      <p>
        ① 회사는 다음과 같은 서비스를 제공합니다.
        <br />
        &nbsp;&nbsp;&nbsp;1. 경영컨설팅 (정책자금 신청 자료 작성 컨설팅, 사업계획서 컨설팅, 세무·법무·재무 관련 일반 정보 제공 및 자문 등)
        <br />
        &nbsp;&nbsp;&nbsp;2. 벤처기업 확인, 기술평가, 이노비즈 등 인증 신청 자료 작성 컨설팅
        <br />
        &nbsp;&nbsp;&nbsp;3. 기업부설연구소 설립 및 운영 컨설팅
        <br />
        &nbsp;&nbsp;&nbsp;4. ISO 인증 신청 자료 작성 및 운영 시스템 구축 컨설팅
        <br />
        &nbsp;&nbsp;&nbsp;5. 경리 운영 지원 (단, 세무 신고·회계 감사 등 자격이 필요한 업무는 제휴 세무사사무소·회계법인이 별도로 수행)
        <br />
        &nbsp;&nbsp;&nbsp;6. 기타 회사가 정하는 부가 서비스
      </p>
      <p>
        ② 회사는 서비스의 내용, 이용방법, 이용시간을 변경할 수 있으며, 이 경우 변경 사유 및 변경된
        내용을 사전에 공지합니다.
        <br />
        ③ 본 사이트에 게시된 정보(상담사례, 인증요건, 혜택 등)는 일반적인 정보 제공을 목적으로
        하며, 개별 기업의 상황에 따라 결과가 달라질 수 있습니다. 회사는 본 사이트에 게시된 정보가
        특정 결과를 보장한다고 표시하지 않으며, 이용자는 정식 컨설팅 계약 체결 전까지 본 사이트의
        정보를 참고용으로만 활용해야 합니다.
      </p>

      <h2 style={h2Style}>제5조 (서비스 이용신청 및 성립)</h2>
      <p>
        ① 이용자는 본 사이트의 상담신청 양식에 회사명, 신청자명, 연락처, 이메일, 사업자등록번호 등
        필수 정보를 정확히 기재하고, 개인정보 수집·이용에 동의함으로써 상담을 신청할 수 있습니다.
        <br />
        ② 회사는 다음 각 호에 해당하는 신청에 대하여는 접수를 거절하거나 사후에 이용계약을 해지할
        수 있습니다.
        <br />
        &nbsp;&nbsp;&nbsp;1. 신청 내용에 허위, 기재누락, 오기가 있는 경우
        <br />
        &nbsp;&nbsp;&nbsp;2. 본 약관에 위반하거나 사회질서 또는 미풍양속에 반할 우려가 있는 경우
        <br />
        &nbsp;&nbsp;&nbsp;3. 기타 회사가 합리적인 판단에 따라 필요하다고 인정하는 경우
        <br />
        ③ 상담신청은 회사의 접수 확인 시점에 성립하며, 정식 컨설팅 계약은 별도의 서면 계약 체결
        시점에 성립합니다.
      </p>

      <h2 style={h2Style}>제6조 (이용자의 의무)</h2>
      <p>이용자는 다음 행위를 하여서는 안 됩니다.</p>
      <p>
        1. 신청 또는 변경 시 허위내용의 등록
        <br />
        2. 회사 또는 제3자의 정보 도용
        <br />
        3. 회사가 게시한 정보의 무단 변경, 복제, 배포
        <br />
        4. 회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 송신 또는 게시
        <br />
        5. 회사 및 제3자의 저작권 등 지적재산권에 대한 침해
        <br />
        6. 회사 및 제3자의 명예를 손상시키거나 업무를 방해하는 행위
        <br />
        7. 외설 또는 폭력적인 정보 등 공서양속에 반하는 정보를 본 사이트에 공개 또는 게시하는 행위
        <br />
        8. 기타 관계법령에 위배되는 행위
      </p>

      <h2 style={h2Style}>제7조 (회사의 의무)</h2>
      <p>
        ① 회사는 관련 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며, 이용자에게
        안정적이고 지속적인 서비스를 제공하기 위해 최선을 다합니다.
        <br />
        ② 회사는 이용자가 안전하게 서비스를 이용할 수 있도록 개인정보(신용정보 포함) 보호를 위한
        보안 시스템을 갖추어야 하며, 개인정보처리방침을 공시하고 준수합니다.
        <br />
        ③ 회사는 이용자로부터 제기되는 의견이나 불만이 정당하다고 인정할 경우 이를 신속히
        처리합니다.
      </p>

      <h2 style={h2Style}>제8조 (개인정보 보호)</h2>
      <p>
        회사는 관계법령에 따라 이용자의 개인정보를 보호하기 위하여 노력하며, 개인정보의 보호 및
        사용에 관한 자세한 사항은 별도의 개인정보처리방침을 따릅니다.
      </p>

      <h2 style={h2Style}>제9조 (서비스 이용제한)</h2>
      <p>
        회사는 이용자가 본 약관 및 관계법령을 위반한 경우 사전 통지 없이 서비스 이용을 제한하거나
        이용계약을 해지할 수 있습니다.
      </p>

      <h2 style={h2Style}>제10조 (계약해지 및 이용계약 해지)</h2>
      <p>
        ① 이용자는 언제든지 회사에 서비스 이용계약 해지를 요청할 수 있으며, 회사는 정당한 사유가
        없는 한 즉시 이를 처리합니다.
        <br />
        ② 정식 컨설팅 계약의 해지·환불 등에 관한 사항은 별도로 체결한 용역 계약서에 따릅니다.
      </p>

      <h2 style={h2Style}>제11조 (면책조항)</h2>
      <p>
        ① 회사는 천재지변, 전쟁, 기간통신사업자의 서비스 중지, 기타 불가항력적 사유로 서비스를
        제공할 수 없는 경우 서비스 제공에 관한 책임을 지지 않습니다.
        <br />
        ② 회사는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.
        <br />
        ③ 본 사이트에 게시된 컨설팅 사례, 인증 요건, 예상 혜택 등 일반적인 정보는 참고용으로
        제공되며, 정식 컨설팅 계약 체결 전 회사가 이용자에게 특정한 결과(인증 취득, 자금 확보 등)를
        보장하지 않습니다. 정식 결과물에 대한 책임 범위는 별도의 용역 계약서에 따릅니다.
        <br />
        ④ 회사는 이용자가 서비스를 이용하여 기대하는 수익을 얻지 못하거나 상실한 것에 대하여
        책임을 지지 않습니다.
        <br />
        ⑤ 회사는 컨설팅 서비스 제공자로서 직접 세무대리, 회계 감사, 법률 사무, 변리 사무 등
        관련 자격이 필요한 업무를 수행하지 않으며, 이러한 업무는 제휴 세무사사무소, 회계법인,
        법률사무소, 특허법인 등 자격을 갖춘 전문기관이 별도의 계약을 통해 수행합니다. 회사는
        이러한 제휴기관 업무에 대한 직접적인 책임을 지지 않으며, 자격이 필요한 업무에 대한
        책임 관계는 해당 전문기관과 이용자 간의 별도 계약에 따릅니다.
        <br />
        ⑥ 회사는 정책자금, 정부지원사업 등의 신청과 관련하여 컨설팅(신청 자료 작성, 일정 관리,
        자료 정리 등)만을 제공하며, 신청 결과(자금 확보, 선정 등)에 대한 권한이나 영향력을 가지지
        않습니다. 모든 신청 결과는 관련 정부 기관 및 공공기관의 심사·결정에 따릅니다.
      </p>

      <h2 style={h2Style}>제12조 (분쟁해결)</h2>
      <p>
        ① 회사와 이용자 간에 발생한 분쟁은 상호 협의하여 해결하는 것을 원칙으로 합니다.
        <br />
        ② 협의가 이루어지지 않은 경우 관계법령에 따른 분쟁조정기관의 조정에 따를 수 있습니다.
        <br />
        ③ 회사와 이용자 간에 제기된 소송에는 대한민국 법을 적용하며, 관할 법원은 회사의 본점
        소재지를 관할하는 법원으로 합니다.
      </p>

      <hr style={{ margin: '40px 0', border: 'none', borderTop: '1px solid #ddd' }} />

      <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 12 }}>부칙</h3>
      <p>본 약관은 2026년 4월 26일부터 적용됩니다.</p>

      <div
        style={{
          marginTop: 40,
          padding: 20,
          background: '#F8F7F4',
          borderRadius: 8,
          fontSize: 13,
          color: '#555',
          lineHeight: 1.7,
        }}
      >
        <p style={{ marginBottom: 6 }}>
          <strong>서비스 공급자</strong>
        </p>
        <p>
          {COMPANY.legalNameKo} · 대표이사: {COMPANY.ceo}
        </p>
        <p>사업자등록번호: {COMPANY.businessNumber}</p>
        <p>
          {COMPANY.address} {COMPANY.addressDetail}
        </p>
        <p>
          문의:{' '}
          <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: '#0F5FCC' }}>
            {CONTACT_EMAIL}
          </a>
        </p>
      </div>

      <div style={{ marginTop: 32, textAlign: 'center' }}>
        <Link
          to="/"
          style={{ color: '#0B1829', textDecoration: 'underline', fontSize: 14, marginRight: 24 }}
        >
          ← 홈으로 돌아가기
        </Link>
        <Link
          to="/privacy"
          style={{ color: '#0B1829', textDecoration: 'underline', fontSize: 14 }}
        >
          개인정보처리방침
        </Link>
      </div>
    </div>
      </main>
      <Footer />
    </div>
  );
}

const h2Style: React.CSSProperties = {
  fontSize: 18,
  fontWeight: 700,
  marginTop: 32,
  marginBottom: 12,
  color: '#0B1829',
};
